import type { FramingComponentEntityTable, FramingComponentId } from "building-types/framing/framingComponentTypes";
import { builtInIJoistComponents, isBuiltInIJoistComponent } from "./defaultIJoistComponents";
import {
  builtInDimensionalLumberFramingComponents,
  isBuiltInDimensionalLumberComponent,
} from "./defaultLumberComponents";

/**
 * IDs for framing-component selects in Studio: when the floor framing feature is off,
 * built-in I-joist catalog entries are hidden unless `ensureIncludedId` must stay selectable.
 */
export function framingComponentIdsForStudioCatalogSelect(
  framingComponents: FramingComponentEntityTable,
  args: {
    readonly floorFramingCatalogEnabled: boolean;
    readonly ensureIncludedId?: FramingComponentId | undefined;
  },
): FramingComponentId[] {
  const ids = Object.keys(framingComponents) as FramingComponentId[];
  const filtered = args.floorFramingCatalogEnabled ? ids : ids.filter((id) => !isBuiltInIJoistComponent(id));
  if (
    args.ensureIncludedId !== undefined &&
    framingComponents[args.ensureIncludedId] !== undefined &&
    !filtered.includes(args.ensureIncludedId)
  ) {
    return [...filtered, args.ensureIncludedId];
  }
  return filtered;
}

/**
 * Built-in `FRAMING_COMPONENT` doc entities seeded into every doc. Includes both the
 * dimensional-lumber catalog (grouped under `builtInFramingComponentsGroup`, displayed
 * as "Dimensional Lumber") and the I-joist catalog (grouped under
 * `iJoistComponentsGroup`, displayed as "I-Joists"). The grouping is wired up in
 * `docDefault.ts`; this table is only the union of seeded entities.
 */
export const builtInFramingComponents: FramingComponentEntityTable = {
  ...builtInDimensionalLumberFramingComponents,
  ...builtInIJoistComponents,
};

export const builtInFramingComponentsGroupId = "builtInFramingComponentsGroup";

export function isBuiltInFramingComponent(id: FramingComponentId): boolean {
  return isBuiltInDimensionalLumberComponent(id) || isBuiltInIJoistComponent(id);
}
